var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"8","height":"6","viewBox":"0 0 8 6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4 0.5L0 5.5L8 5.5L4 0.5Z","fill":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }